<template>
  <v-app>
    <div class="background">
      <HeaderDefault id="home" simple />
      <MainDocuments />
      <FooterLinks />
    </div>
  </v-app>
</template>

<script>
import { HeaderDefault, MainDocuments, FooterLinks } from "@/components/layouts"

export default {
  name: "App",
  components: {
    HeaderDefault,
    MainDocuments,
    FooterLinks,
  },
}
</script>
